import React, { useState } from 'react'
import { NavSearch } from '../../../../constants/svg'
import Search from '../../search'
import { HeaderSearch } from '../style'

export const SearchIcon = () => {
  const [showSearch, setShowSearch] = useState(false)
  let bodyElement: any

  const handleSearchClick = (e: any) => {
    e.preventDefault()

    if (!showSearch) {
      let searchInput: any = document.querySelector('#gcs__input')

      if (searchInput) {
        searchInput?.focus()
        if (bodyElement) {
          bodyElement.classList.add('overflow-hidden')
        }
      }
    } else {
      if (bodyElement) {
        bodyElement.classList.remove('overflow-hidden')
      }
    }

    setShowSearch(!showSearch)
  }

  return (
    <>
      <HeaderSearch className="headerSearch" data-cy="headerSearch" onClick={handleSearchClick}>
        <a className="MainHeader-gcsSearchButton searchIcon">
          <NavSearch />
        </a>
      </HeaderSearch>
      <Search open={showSearch} handleSearchClick={handleSearchClick} />
    </>
  )
}
